/*
 * This component will be rendered when a user does not have the required permissions to view a certain.
 */

import { Box } from "@mui/material";

export const PermissionDenied = () => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h2>
        You do not have correct permissions to access this page. Please check
        your permissions.
      </h2>
    </Box>
  );
};
